import { getUnit, formatUnitValue } from "../einheiten/Units";

export const genUnitValueFormatter = (unit_name, units, intl, show_unit = false) => {
	return value => {
		let unit = getUnit(units[unit_name]);
		let result = formatUnitValue(value, unit, intl);
		if (show_unit) {
			result += " ";
			result += unit.genUnitText(intl);
		}
		return result;
	};
};
